<template>
    <mds-layout-grid>
        <mds-row e2e="time-period-summary">
            <mds-col :cols="3">
                <div class="summary-label">
                    {{ $store.getters["hypo/getType"] === 2 ? getUILabel("investments_time_period") : getUILabel("holdings_time_period") }}
                </div>
                <div class="summary-text">{{ timePeriodLabel }}</div>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "holdings-summary",
    props: {
        globalTimePeriod: [Number, String]
    },
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        timePeriodLabel() {
            const currentTimePeriodId = this.globalTimePeriod;
            if (currentTimePeriodId === -1) {
                return this.getUILabel("COMMON_VAH");
            }
            const currentTimePeriodOption = this.$store.getters["holdings/timePeriodOptions"].find(item => item.value === currentTimePeriodId);
            return currentTimePeriodOption ? this.getUILabel(currentTimePeriodOption.labelId) : "";
        }
    }
};
</script>
